export const PIN_CODE_FOR_DELIVERY = "pinCodeDel";
export const UPI_VERIFICATION_EXPERIMENT = "UPI_V";
export const CRED_PAY_TITLE = "CRED Pay";
export const CRED_PAY_UPI = "CRED Pay UPI";
export const NYKAA_USER = "nykaa user";
export const ITEMS_OUT_OF_STOCK = "Items out of stock";
export const OUT_OF_STOCK_MESSAGE =
  "A few items in your cart are now out of stock. Please update your cart to complete the order.";
export const SERVER_ERROR_MESSAGE =
  "Hm, our servers hiccupped for a moment there. A quick retry should do the trick!";

export enum userSessionTypes {
  GUEST = "guest",
  LOGGED_IN = "logged_in",
}

export enum platformNames {
  NYKAA = "nykaa",
  MEN = "men",
  FASHION = "fashion",
  FOOTLOCKER = "FOOT_LOCKER",
  NYKAAD = "nykaaD",
}

export enum standardErrorMessages {
  SOMETHING_WRONG = "Something went wrong!",
  OOPS = "Oops! Something went wrong...",
}

export const PRODUCT_ADDED_TO_CART = "Product Added to Cart!";
export enum deviceTypes {
  M_SITE = "msite",
  M_WEB = "mweb",
}

export enum variantTypes {
  SIZE = "SIZE",
  SHADE = "SHADE",
  SIMPLE = "SIMPLE",
}

export enum ORIGIN_SOURCE {
  CART = "cart_page",
  ADDRESS = "address_page",
  PAYMENTS = "checkout_page",
  CHECKOUT_AUTH = "checkout_auth_page",
}

export const CURRENCY = "INR";

export const RANDOM_NUMBER_COOKIE_KEY = "run";
export const RUN_MAX_AGE = 30;

export const GENERIC_MESSAGE_PAGE = {
  ADDRESS_PAGE: "shippingAddressPage",
  PAYMENT_SUCCESS_PAGE: "orderConfirmationPage",
};

export const GENERIC_MESSAGE_TYPE = {
  INFO: "info",
  ERROR: "error",
  WARN: "warn",
};

export const ERROR_MODAL_TITLE = {
  FAILED: "PAYMENT FAILED",
  SERVER_ERROR: "SERVER ERROR",
  SOMETHING_WENT_WRONG: "Something went wrong",
};

export const ERROR_MODAL_DEFAULT_MESSAGE = {
  ORDER_ID_MISSING: "Order Id is missing",
  HASH_VALUE_MISSING: "Hash value is missing",
};

export const COUNTRY_CODE_COOKIE_KEY = "countryCode";
export const COUNTRY_CODE_INDIA = "IN";
export const NEW_PAYMENT_PRE_CONFIRMATION_COOKIE = "N_P_P_C";
export const NYKAA_FASHION = "nykaafashion";

export const ACCORDIAN = {
  PREFERRED: "preferred",
  SNPL: "snpl",
  COD: "cod",
  CREDIT_CARD: "cc",
  UPI: "upi",
  EMI: "emi",
  GIFT_CARD: "gift",
  NETBANKING: "nb",
  PAYTM: "paytm",
  GPAY_INTENT: "upi_intent",
  SIMPL: "simpl",
  LAST_METHOD: "last",
  CRED: "cred",
  UPI_INTENT: "upi_intent",
};

export const PAGE_NAMES = {
  SAVED_ADDRESS: "savedAddressPage",
  ADD_NEW_ADDRESS: "addNewAddressPage",
  SAVED_PAYMENT_PAGE: "savedPaymentPage",
  DESKTOP_PAYMENT_PAGE: "desktopPaymentPage",
  PAYMENT_PAGE: "paymentPage",
  CART_PAGE: "cartPage",
  EDIT_ADDRESS_PAGE: "editAddressPage",
  FRESH_PAYMENT_PAGE: "freshPaymentPage",
  PAYMENT_FAILURE_BOTTOMSHEET: "payment_failure_bottomsheet",
  PAYMENT_FAILURE_2: "payment_failure_2",
  PAYMENT_FAILURE_1: "payment_failure_1",
  CHECKOUT_FLOW_ADDRESS: "checkoutFlowAddressPopUp",
  IMPORT_PAGE: "importPage",
  PAYMENT_BOTTOMSHEET: "payment_bottomsheet"
};

export const PAGE_TYPES = {
  ADDRESS_PAGE: "addressPage",
  PAYMENT_PAGE: "paymentPage",
};
export const POST_MESSAGE_TYPE = {
  ORDER_CONFIRMATION_DEKSTOP: "ORDER_CONFIRMATION_DEKSTOP",
  MY_SAVED_PAYMENT_DEKSTOP: "MY_SAVED_PAYMENT_DEKSTOP",
};

export const NOT_AVAILABLE = "notAvailable";
export const NA = "NA";

export const STORAGE_KEYS = {
  ITEM_TRACKING_PARAM: "ITEM_TRACKING_PARAM",
  ORDER_ID: "orderId",
  REMOVE_COUPON_ID: "REMOVE_COUPON_ID",
  NYK_ORDER_ID: "nyk_order_id"
};
export const TRACKING_EVENTS = {
  CHECKOUT_EXPERIMENTS: "checkout_experiments",
  SAVED_PAYMENT_LOADS: "saved_payment_loads",
  PAYMENT_PAGE_LOADS: "payment_page_loads",
  PAY_NOW_CLICKED: "pay_now_clicked",
  ORDER_CREATED: "order_created",
  ADD_NEW_ADDRESS_PAGE_LOAD: "add_new_address_loads",
  SAVED_ADDRESS_PAGE_LOAD: "saved_address_loads",
  ERROR_PAGE_LOAD: "error_page_loads",
  ORDER_PLACED: "order_placed",
  ORDER_ITEM_PLACED: "order_item_placed",
  PAYMENT_METHOD_CLICK: "payment_method_click",
  OTHER_PAYMENT_METHOD_CLICK: "other_payment_method_clicks",
  PAYMENT_OFFER_WIDGET_CLICK: "payment_offer_widget_click",
  ADDRESS_AUTO_DETECT_CLICK: "address_auto_detect_click",
  ADDRESS_AUTO_DETECT_INTERACTION: "address_auto_detect_interaction",
  ADDRESS_AUTO_DEECT_CONFIRM: "address_auto_detect_confirm",
  ADDRESS_AUTO_DETECT_EDIT: "address_auto_detect_edit",
  EDIT_ADDRESS_LOADS: "edit_address_loads",
  SHIP_TO_ADDRESS_CLICKS: "ship_to_address_clicks",
  SAVE_CARD_KNOW_MORE: "save_card_know_more",
  CARD_SAVED_AS_PER_RBI: "card_saved_as_per_rbi",
  PAYMENT_FAILED_EVENT: "payment_failed",
  DELIVERY_ESTIMATE_TOOLIP_EXPAND: "delivery_estimate_tooltip_expand",
  PRICE_DETAILS_TOOPTOP_EXPAND: "price_details_tooltip_expand",
  ADDRESS_DETAILS_TOOLTIP_EXPAND: "address_details_tooltip_expand",
  SNPL_ELIGIBILITY_CHECKED: "snpl_eligiblity_checked",
  // clevertap events
  PAYMENT_INITIATED: "PaymentInitiated",
  PAYMENT_SUCCESSFUL: "PaymentSuccessful",
  PAYMENT_FAILED: "PaymentFailed",
  CHECKOUT: "Checkout",
  CRED_DETAILS: "credDetails",
  // events for payment failure flow
  FAILURE_BOTTOMSHEET_LOAD: "payment_failure_bottom_sheet_load",
  FAILURE_BOTTOMSHEET_CROSS_BUTTON_CLICK: "payment_failure_bottom_sheet_cross_button",
  FAILURE_BOTTOMSHEET_OTHER_PAYMENT_CLICK: "bottom_sheet_other_payment",
  FAILURE_BOTTOMSHEET_RETRY_BUTTON_CLICK: "bottom_sheet_retry_button",
  PAYMENT_RESPONSE_STATUS: "payment_response_status",
  // back friction tracking
  PAYMENT_BACK_FRICTION_LOADS: "checkout_back_bs_loads",
  PAYMENT_BACK_FRICTION_CLOSED: "checkout_back_bs_closed",
  PAYMENT_BACK_FRICTION_PROCEED: "checkout_back_bs_proceed",

  PAYMENT_ERROR_POPUP: "payment_error_popup",
  PAYEMNT_ERROR_POPUP_CLICK: "payment_error_popup_click",
  PAYMENT_OFFER_CLICKED: "payment_offer_clicked",
  ADD_MONEY_PAYTM: "add_money_paytm",
  WEBVIEW_TAB_ACTIVE: "webview_tab_active",
  WEBVIEW_TAB_INACTIVE: "webview_tab_inactive",
  POST_PAYMENT_PAGE_LOADS: "post_payment_page_loads",
  DO_REDIRECT_TO_NATIVE_CONFIRMATION_CALLED: "do_redirect_to_native_confirmation_called",
  ADDRESS_BACK_BOTTOMSHEET_CLICK: "address_back_bottomsheet_clicked",
  ADDRESS_BACK_BOTTOMSHEET_LOADS: "address_back_bottomsheet_loads",
  HIGH_MEMORY_UTILISATION: "high_memory_utilisation",
  EXPRESS_CHECKOUT_PAGE_LOAD: "express_checkout_page_load",
  EXPRESS_CHECKOUT_ERROR: "express_checkout_error",
  EXPRESS_CHECKOUT_PAY_CLICKED: "express_checkout_pay_clicked",
  EXPRESS_CHECKOUT_CLOSED: "express_checkout_closed",
  EXPRESS_CHECKOUT_ADDRESS_CHANGE: "express_checkout_address_change",
  EXPRESS_CHECKOUT_PAYMENT_MODE_CHANGE: "express_checkout_payment_mode_change",
  EXPRESS_CHECKOUT_PMNA_LOAD: "express_checkout_pmna_load", // Event for payment method not available on express checkout
  EXPRESS_CHECKOUT_ENTER_CVV: "express_checkout_enter_cvv",
  SWIPE_TO_PAY: "slide_to_pay",
  EXPRESS_CHECKOUT_DELAY_SCREEN_LOADS: "ec_delayscreen_loads",
  EXPRESS_CHECKOUT_DELAY_SCREEN_CHANGE_PAYMENT: "ec_delayscreen_change_payment",
};

export const STATE_TYPE_EVENTS = [
  TRACKING_EVENTS.SAVED_PAYMENT_LOADS,
  TRACKING_EVENTS.PAYMENT_PAGE_LOADS,
  TRACKING_EVENTS.ADD_NEW_ADDRESS_PAGE_LOAD,
  TRACKING_EVENTS.SAVED_ADDRESS_PAGE_LOAD,
  TRACKING_EVENTS.OTHER_PAYMENT_METHOD_CLICK,
];
export const VISITOR_BLOCKED = "visitor blocked";

export const DEVICE_TYPE = {
  MOBILE: "MSITE",
  DESKTOP: "WEBSITE",
  ANDROID: "ANDROID",
  IOS: "IOS",
};

export const DATE_FORMATS = { PAYMENT_OFFER: "d MMM yyyy" };

export enum DEVICE {
  MOBILE = "mobile",
  DESKTOP = "desktop",
}

export enum BUTTON_TYPE {
  SMALL = "small",
  MEDIUM = "medium",
  LARGE = "large",
}

export enum DESKTOP_PAGES {
  PAYMENT = "payment",
  AUTH = "auth",
  ADDRESS = "address",
}

export enum PAYMENT_INFO {
  ZEST = "zest",
  CARD = "savedCardDTOList",
  NB = "netBankingList",
  UPI = "customerVpaList",
  SIMPL = "simplDTO",
  PAYTM = "paytmUserDTO",
}

export enum PAYMENT_OFFER_RESPONSE_CODE {
  USAGE_EXHAUSTED = "USAGE_EXHAUSTED",
  INSTRUMENT_VALIDATE = "INSTRUMENT_VALIDATE",
  NYKAA_FUNDED_COUPON_APPLIED = "NYKAA_FUNDED_COUPON_APPLIED",
  MIN_PAYABLE_VALIDATION = "MIN_PAYABLE_VALIDATION",
}

/**
 * when cron is running at backend , then /paymentConversion Api will
 * give 3007 status code
 */
export const CRON_RUN_STATUS_CODE = "3007";

/**
 * It is for priority based on payment method and only for new payment methods.
 */

export const PAYMENT_METHOD_PRIORITY = {
  [ACCORDIAN.UPI]: 1,
  [ACCORDIAN.CREDIT_CARD]: 2,
  [ACCORDIAN.COD]: 3,
  [ACCORDIAN.NETBANKING]: 4,
  [ACCORDIAN.SNPL]: 5,
  [ACCORDIAN.CRED]: 6,
  [ACCORDIAN.PAYTM]: 7,
  [ACCORDIAN.GIFT_CARD]: 8,
  [ACCORDIAN.EMI]: 9,
};

/**
 * function returns the new payment method priority
 * from remote config.
 */
export const getPaymentMethodPriority = () => {
  const { remoteConfig } = window as any;
  const priority = remoteConfig?.configs?.payment?.paymentMethodPriority;
  if (!priority) return PAYMENT_METHOD_PRIORITY;

  return {
    [ACCORDIAN.UPI]: priority[ACCORDIAN.UPI] || PAYMENT_METHOD_PRIORITY[ACCORDIAN.UPI],
    [ACCORDIAN.CREDIT_CARD]:
      priority[ACCORDIAN.CREDIT_CARD] || PAYMENT_METHOD_PRIORITY[ACCORDIAN.CREDIT_CARD],
    [ACCORDIAN.COD]: priority[ACCORDIAN.COD] || PAYMENT_METHOD_PRIORITY[ACCORDIAN.COD],
    [ACCORDIAN.NETBANKING]:
      priority[ACCORDIAN.NETBANKING] || PAYMENT_METHOD_PRIORITY[ACCORDIAN.NETBANKING],
    [ACCORDIAN.SNPL]: priority[ACCORDIAN.SNPL] || PAYMENT_METHOD_PRIORITY[ACCORDIAN.SNPL],
    [ACCORDIAN.CRED]: priority[ACCORDIAN.CRED] || PAYMENT_METHOD_PRIORITY[ACCORDIAN.CRED],
    [ACCORDIAN.PAYTM]: priority[ACCORDIAN.PAYTM] || PAYMENT_METHOD_PRIORITY[ACCORDIAN.PAYTM],
    [ACCORDIAN.GIFT_CARD]:
      priority[ACCORDIAN.GIFT_CARD] || PAYMENT_METHOD_PRIORITY[ACCORDIAN.GIFT_CARD],
    [ACCORDIAN.EMI]: priority[ACCORDIAN.EMI] || PAYMENT_METHOD_PRIORITY[ACCORDIAN.EMI],
  };
};
